import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

//internal import
import EmployeeService from "../services/EmployeeService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useEmployeeSubmit = (id) => {

  const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

  const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

  const [imageUrl, setImageUrl] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [viewData, setviewData] = useState([]);


  // add and update employee details
  const onSubmit = async (data) => {

    setPageLoading(true);

    try {
      data.employeeProfileImage = imageUrl;
      const response = id ? await EmployeeService.UpdateEmployeeById(id, data) : await EmployeeService.addEmployee(data);
      if (response?.success) {
        notifySuccess(response.message);
        setIsModal(false);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response.message);
      }
    } catch (error) {
      console.error(error);
      notifyError(error?.response?.data?.message || error.message);
    } finally {
      setPageLoading(false);
    }
  };

  //  delete employee by id 
  const handleDeleteEmployee = async (id) => {
    try {
      const response = await EmployeeService.deleteEmployeeById(id);
      if (response.success) {
        notifySuccess(response?.message);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response?.message);
      }
      setIsDeleteModal(false);
    }
    catch (error) {
      console.error("error", error);
      notifyError(error?.response?.data?.message || error.message);
      setIsDeleteModal(false);
    }
  }

  useEffect(() => {
    reset();
    if (id) {
      (async () => {
        try {
          const res = await EmployeeService.getEmployeeById(id);
          const data = res?.data;

          if (res?.success) {
            setviewData(data);
            setValue("employeeUsername", data.employeeUsername);
            setValue("emailId", data.emailId);
            setValue("employeeName", data.employeeName);
            setValue("employeeProfileImage", data.employeeProfileImage);
            setValue("employeeCode", data.employeeCode);
            setValue("joiningDate", dayjs(data.joiningDate).format("YYYY-MM-DD"));
            setValue("gender", data.gender);
            // setValue("password", data.password);
            setValue("phone", data.phone);
            setValue("department", data.department?._id);
            setValue("designation", data?.designation);
            setValue("timezone", data?.timezone);
            setValue("workingHour", data?.workingHour);
            setImageUrl(data.employeeProfileImage);
          }
        } catch (error) {
          console.error("Error fetching employee data:", error);
        }
      })();
    }
    else{
          setValue("workingHour", 9);
    }
  }, [isModal, id]);

  return {
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    handleDeleteEmployee,
    pageLoading,
    imageUrl,
    setImageUrl,
    isModal,
    setIsModal,
    isViewModal,
    setIsViewModal,
    isDeleteModal,
    setIsDeleteModal,
    viewData,
  }
}

export default useEmployeeSubmit;